import { useResizableColumns } from "@/lib/sortableTable";

// Column layout for the realtors list. Widths persist per-user via
// localStorage (handled inside `useResizableColumns`). Sortable flags
// pair with the SORT_GETTERS map below so a header click can re-order
// the in-memory list without a server roundtrip.
const REALTOR_COLS = [
  { key: "name",       label: "Name",       width: 260, sortable: true },
  { key: "brokerage",  label: "Brokerage",  width: 220, sortable: true },
  { key: "contact",    label: "Contact",    width: 200, sortable: true },
  { key: "enrichment", label: "Enrichment", width: 220, sortable: true },
  { key: "scan_count", label: "Scans",      width: 100, sortable: true },
  { key: "socials",    label: "Socials",    width: 200, sortable: false },
  { key: "actions",    label: "Actions",    width: 130, sortable: false },
];

// Per-column sort getters. Keys MUST match REALTOR_COLS entries. Fed
// into `applyClientSort()` in the list page.
export const REALTOR_SORT_GETTERS = {
  name: {
    getSortValue: (r) =>
      r.name || `${r.first_name || ""} ${r.last_name || ""}`.trim(),
  },
  brokerage: { getSortValue: (r) => r.brokerage_name || "" },
  contact: { getSortValue: (r) => r.email || r.phone || "" },
  enrichment: {
    getSortValue: (r) =>
      [
        "facebook_url",
        "instagram_url",
        "linkedin_url",
        "twitter_url",
        "tiktok_url",
        "youtube_url",
        "threads_url",
      ].filter((f) => (r[f] || "").trim()).length,
  },
  scan_count: { getSortValue: (r) => Number(r.scan_count) || 0 },
};

// Hook returns the resizable/sortable column state used to render the
// `<colgroup>` + `<SortableTH>` set in Realtors.jsx.
export function useRealtorColumns() {
  return useResizableColumns("realtors-list", REALTOR_COLS);
}
